import { NotificationsMockApi } from 'app/mock-api/common/notifications/api';

export const mockApiServices = [NotificationsMockApi];
